module.exports = __webpack_public_path__ + "static/media/05ю11.6af729f5.webp";